import { render, staticRenderFns } from "./SubscriptionsType.vue?vue&type=template&id=b6068b0a&scoped=true&"
import script from "./SubscriptionsType.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsType.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsType.vue?vue&type=style&index=0&id=b6068b0a&prod&scoped=true&lang=css&"
import style1 from "./SubscriptionsType.vue?vue&type=style&index=1&id=b6068b0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6068b0a",
  null
  
)

export default component.exports